import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ResponseUtil } from '../../utils/response-util';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';

@Injectable()
export class VersionHttpService {
  private pulse: string = this.environment.baseUrl + '/pulse';

  constructor(private http: Http,
              private environment: EnvironmentConfiguration) {
  }

  getFrontendVersion(): Observable<Object> {
    return this.http.get('/assets/version.json')
      .map((res: Response) => res.json()).catch(ResponseUtil.unwrapErrorMessage).share();
  }

  getBackendVersion(): Observable<Object> {
    return this.http.get(this.pulse)
      .map((res: Response) => res.json()).catch(ResponseUtil.unwrapErrorMessage).share();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/version/service/version.http.service.ts